import React, { useContext, useState, useEffect } from "react";
import { ThemeContext } from "../../../context/ThemeContext";
import KPIChartsContainer from "../../components/charts/my_charts/KPIChartsContainer";
const LearningOutcomes = () => {

    const { changeBackground, background } = useContext(ThemeContext);
    const [loading, setLoading] = useState(true);
    const [hasSearched, setHasSearched] = useState(false);
  
    const [years, setYears] = useState([]);
    const [selectedYear, setSelectedYear] = useState(null);
  
    const [performanceStatusCount, setPerformanceStatusCount] = useState({
      exceeded: 0,
      achieved: 0,
      below_target: 0

    });
  
    
    const fetchYears = async () => {
      try {
        const response = await fetch(
          "https://plo.areez.co//api/university/academic_years"
        );
  
        if (!response.ok) throw new Error("فشل في تحميل بيانات");
        const data = await response.json();
        setYears(data);
         setSelectedYear(data[0].id);
      setTimeout(() => {
        handleSearch(data[0].id);
      }, 0);
      } catch (error) {
        console.error("خطأ:", error);
        setYears([]);
      } finally {
        setLoading(false);
      }
    };

    const fetchPerformanceStatusCount = async (academicYearId) => {
        try {
          const response = await fetch(
            `https://plo.areez.co/api/kpi/performance_status/count?academic_year_id=${academicYearId}`
          );
          if (!response.ok) throw new Error("فشل في تحميل البيانات");
    
          const data = await response.json();
          setPerformanceStatusCount({
            exceeded: data.exceeded,
        achieved: data.achieved,
        below_target: data.below_target
      
          });
        } catch (error) {
          console.error("خطأ في تحميل البيانات:", error);
          setPerformanceStatusCount({
            exceeded: 0,
            achieved: 0,
            below_target: 0
          });
        } finally {
          setLoading(false);
        }
      };
  
  
    const handleSearch = (yearId) => {
      // if (!selectedYear) {
      //   alert("يرجى اختيار السنة الدراسية أولاً.");
      //   return;
      // }
      const yearToUse = yearId || selectedYear;
      if (!yearToUse) {
        alert("يرجى اختيار السنة الدراسية أولاً.");
        return;
      }
      setLoading(true);
      setHasSearched(true);
      fetchPerformanceStatusCount(yearId);
    };
  
    useEffect(() => {
      fetchYears();
  
      changeBackground({ value: "light", label: "Light" });
    }, []);
  
    return (
      <div className="row">
        <div className="col-12 mb-4">
          <div className="input-group">
            <select
              className="form-control"
              value={selectedYear || ""}
              onChange={(e) => setSelectedYear(e.target.value)}
            >
              <option value="">اختر السنة الدراسية</option>
              {years.map((year) => (
                <option key={year.id} value={year.id}>
                  {year.name}
                </option>
              ))}
            </select>
            <div className="input-group-append">
              <button
                className="btn btn-primary"
                // onClick={handleSearch}
              onClick={() => handleSearch(selectedYear)}
                disabled={loading}
              >
                <i className="fa fa-search mr-1"></i>{" "}
                {loading ? "جارٍ البحث..." : ""}
              </button>
            </div>
          </div>
        </div>
  
        {!selectedYear && (
  <div className="col-12 mt-5">
    <div className="alert alert-warning text-center">
      يرجى اختيار السنة الدراسية لعرض النتائج.
    </div>
  </div>
)}
{(performanceStatusCount.exceeded === 0 &&
  performanceStatusCount.achieved === 0 &&
  performanceStatusCount.below_target === 0) ? (
  <p style={{ textAlign: 'center', marginTop: '20px' }}>
  </p>
) : (
  <>
    <div className="col-12 col-lg-4 mb-4">
      <div className="widget-stat card bg-primary">
        <div className="card-body p-4">
          <div className="media pb-2">
            <span className="mr-3">
              <i className="fa fa-trophy  text-white"></i>
            </span>
            <div className="media-body text-white">
              <p className="mb-1">عدد المؤشرات التي تجاوزت المستهدف</p>
              <h3 className="text-white">{performanceStatusCount.exceeded || 0}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="col-12 col-lg-4 mb-4">
      <div className="widget-stat card bg-success">
        <div className="card-body p-4">
          <div className="media pb-2">
            <span className="mr-3">
              <i className="fa fa-check-circle  text-white"></i>
            </span>
            <div className="media-body text-white">
              <p className="mb-1">عدد المؤشرات التي حققت المستهدف</p>
              <h3 className="text-white">{performanceStatusCount.achieved  || 0}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="col-12 col-lg-4 mb-4">
      <div className="widget-stat card bg-warning">
        <div className="card-body p-4">
          <div className="media pb-2">
            <span className="mr-3">
              <i className="fa fa-exclamation-triangle  text-white"></i>
            </span>
            <div className="media-body text-white">
              <p className="mb-1">عدد المؤشرات التي لم تحقق المستهدف</p>
              <h3 className="text-white">{performanceStatusCount.below_target  || 0}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div className="col-12 mt-4">
    <KPIChartsContainer selectedYear={selectedYear} />
  </div>
  </>
)}





  
      </div>
    );
}

export default LearningOutcomes;